<template>
  <div class="charts-page">

    <div class="row">
      <div class="flex md12 xs12">
        <sp-360-panel
          class="chart-widget"
          :title="$t('menu.rent-support')"
        >
          <iframeBI :fonte='fonte'> </iframeBI>
        </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>

import constantes from '@/utils/ConstantesGlobais'
import MetodosGlobais from '@/utils/MetodosGlobais'
import _ from 'lodash'
import iframeBI from '@/components/iframe/implementacoes/iframeBI'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  name: 'auxilio-aluguel',
  components: {
    iframeBI,
    Sp360Panel,
  },
  data: () => ({
    dados: {},
    chartData: {},
    bChartData: {},
    options: {},
    fonte: '',
  }),
  created () {
    this.buscarLinkBi()
  },
  methods: {
    buscarLinkBi () {
      this.$store.dispatch('iframeDashboard/buscarUrlIframe', { nome: constantes.LINK_IFRAME.POPULACAO.AUXILIO_ALUGUEL })
        .then((retorno) => {
          this.fonte = retorno.data.url
          this.dataRef = new Date(retorno.data.data_referencia_dado).toLocaleDateString('pt-BR')
          this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })

        }).catch((error) => {
          console.error(error)
        })
    },
  },
}
</script>

<style lang="scss">
.widget.chart-widget {
  .widget-body {
    height: 550px;
  }
}
</style>